module.exports = __webpack_public_path__ + "static/media/a33.b1615232.jpg";